import { render, staticRenderFns } from "./AnalisisProductividadComercial.vue?vue&type=template&id=0005f27e"
import script from "./AnalisisProductividadComercial.vue?vue&type=script&lang=js"
export * from "./AnalisisProductividadComercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports